module.exports = __webpack_public_path__ + "img/malawi.d03cfb49.svg";